export default {
  app: {
    languagePopup: {
      title: '현재 {logo}의 영어 버전을 사용 중입니다',
      subtitle: '선호하는 언어로 전환하시겠습니까?',
      cta: '{lang}로 전환',
    },
  },
};
